/**
 * Thin re-export of the canonical graph mutation primitives in
 * `model/xyflow/mutations.ts`. Kept as a barrel so existing call sites
 * (`utils/workflowGraphOps`) continue to work without rippling import
 * changes — but the implementation now lives in one place.
 */
import type { WorkflowNode } from 'model/xyflowMapping';
import { buildNewNodes, removeStepOutputRefs } from 'model/xyflow/mutations';

/**
 * Build the new xyflow node(s) for a palette drop. Returns an array because
 * `forEach` drops also spawn `startIteration` + `endIteration` child nodes.
 * Returns `null` when the drop is invalid (e.g. dropping a second `initial`).
 *
 * Now a thin wrapper around `buildNewNodes` from the mutations module so
 * the canvas drop handler and the page-level "add node" handlers share
 * one node-construction path.
 */
export const createNodesFromDrop = (
  actionId: string,
  position: { x: number; y: number },
  existingNodes: WorkflowNode[],
): WorkflowNode[] | null => buildNewNodes(actionId, position, existingNodes);

export { removeStepOutputRefs };
